import React from 'react';
import s from './container.module.scss';

export default React.forwardRef(({ children, className, noSection, ...props }, ref) => (noSection ? (
  <div ref={ref} {...props} className={`container ${s.paddings} ${className || ''}`}>{children}</div>
) : (
  <section ref={ref} className={` ${s.paddings}  ${className || ''}`} {...props}>
    <div className="container">{children}</div>
  </section>
)));
